module.exports = __webpack_public_path__ + "static/media/no-result-without-fill.51b35dac.png";